module.exports = __webpack_public_path__ + "static/media/lds-logo_pt.3ef4a155.svg";